// extracted by mini-css-extract-plugin
export default {"root":"IconEdit_root__DX3RQ","pencil":"IconEdit_pencil__uLVVP"};